import TicketFillters from 'components/filters/ticketsFillters'
import React, { useState } from 'react'
import useSearchClient from 'hooks/query/searchClient/useSearchClient';
import { useTranslation } from 'react-i18next';
import { Card, Col, Flex, Row, Spin } from 'antd';
import i18next from 'i18next';
import { Link } from 'react-router-dom';



const SearchClient = () => {
  const contentStyle: React.CSSProperties = {
  padding: 50,
  background: 'rgba(0, 0, 0, 0.05)',
  borderRadius: 4,
  };
  const content = <div style={contentStyle} />;
    const { t } = useTranslation();
    const [SearchText, setSearch] = useState<string>("");
    const { data, isLoading, isFetching, refetch } = useSearchClient(SearchText);
    console.log(data)
    console.log(data?.data?.contractors)
    console.log(data?.data?.companies)
    return (
      <div>
        <TicketFillters
          setSearch={(search: string) => setSearch(search)}
          refetch={() => refetch()}
          isFetching={isFetching}
        />
        {
          SearchText 
          ?
          <div>
            <div style={{marginBottom: "50px"}}>
              <p>{t("contractors") + ":"}</p>
              {
                isLoading || isFetching 
                ?
                  <Flex style={{justifyContent: "center", alignItems: "center"}}  gap="middle" vertical>
                      <Spin size="large">
                          {content}
                      </Spin>
                  </Flex>
                :
                  Array.isArray(data?.data?.contractors) && data?.data?.contractors?.length !== 0
                  ?                   
                  <Row gutter={[16,16]} style={{textAlign: i18next.language === "en" ? "left" : "right", marginTop: "10px"}}>
                    {data?.data?.contractors.map((element, index) => (
                        <Col key={index} md={8} sm={12} xs={24}>
                          <Card title={`${t("contractor_name")} : ${element?.name}`} variant="borderless">
                            <p>{`${t("email")} : ${element?.email || "-"}`}</p>
                            <p>{`${t("phone_number")} : ${element?.phone_number || "-"}`}</p>
                            <Link style={{display: "flex", justifyContent: "flex-end"}} to={`/customers/clients/${element?.id}`}>{t("show_more")}</Link>
                          </Card>
                        </Col>
                    ))}
                  </Row>
                  : 
                  <div style={{marginBottom: "50px"}}>
                    <p style={{display: "flex", justifyContent: "center", alignItems: "center"}}>{t("no_contractors_found")}</p>
                  </div>
              }
            </div>
            <div>
              <p>{t("companies") + ":"}</p>
              {
                isLoading || isFetching 
                ?
                  <Flex style={{justifyContent: "center", alignItems: "center"}}  gap="middle" vertical>
                      <Spin size="large">
                          {content}
                      </Spin>
                  </Flex>
                :
                Array.isArray(data?.data?.companies) && data?.data?.companies?.length !== 0
                ?                   
                  <Row gutter={[16,16]} style={{textAlign: i18next.language === "en" ? "left" : "right", marginTop: "10px"}}>
                    {data?.data?.companies.map((element, index) => (
                        <Col key={index} md={8} sm={12} xs={24}>
                          <Card title={`${t("company_name")} : ${element?.name || element?.name_en || element?.name_ar || "-"}`} variant="borderless">
                            <p>{`${t("classification_company")} : ${element?.classification?.name}`}</p>
                            <p>{`${t("phone_number")} : ${element?.phone || "-"}`}</p>
                            <Link style={{display: "flex", justifyContent: "flex-end"}} to={`/customers/classifications/${element?.classification?.id}`}>{t("show_more")}</Link>
                          </Card>
                        </Col>
                    ))}
                  </Row>
                : 
                <div style={{marginBottom: "50px"}}>
                  <p style={{display: "flex", justifyContent: "center", alignItems: "center"}}>{t("no_companies_found")}</p>
                </div>
              }
            </div>
          </div>
          :
            <div style={{display: "flex", justifyContent: "center", alignItems: "center", marginTop: "50px", marginBottom: "50px"}}>
              <p>{t("write_to_search_min_3_chars")}</p>
            </div>
        }
      </div>
    )
}

export default SearchClient